import { connect } from 'react-redux';
import { NavSamplesActionBar } from '../../components/nav/NavSamplesActionBar';
import {
  queryParamsShiftLeft,
  queryParamsShiftRight,
  queryParamsZoomOut
} from '../../actions/queryParams';

const mapStateToProps = (state, ownProps) => ({
  loading: state.loading.samples,
  pageType: ownProps.pageType
});

const NavSamplesAction = connect(mapStateToProps, {
  queryParamsShiftLeft,
  queryParamsShiftRight,
  queryParamsZoomOut
})(NavSamplesActionBar);

export default NavSamplesAction;



// WEBPACK FOOTER //
// ./src/container/nav/NavSamplesAction.js